import { render, staticRenderFns } from "./AdminCreditNotes.vue?vue&type=template&id=4f376639"
import script from "./AdminCreditNotes.vue?vue&type=script&lang=js"
export * from "./AdminCreditNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports